import React, { useState, useEffect } from 'react';
import { createDoctor, updateDoctor } from '../../logic/settings';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Form, FormControl, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clearStorage } from './../../libs/general';

function DoctorDetails() {
	const navigate = useNavigate();
	const location = useLocation();
	const [doc, setDoc] = useState({
		docId: '',
		title: '',
		name: {
			firstName: '',
			lastName: ''
		},
		mobile: {
			mobileNumber: ''
		},
		speciality: '',
		email: '',
		isFavourite: false,
		clinic: 'Clinic 1'
	});
	const [editMode, setEditMode] = useState(false);
	const [error, setError] = useState('');

	useEffect(() => {
		if (location && location.state && location.state.doc) {
			const { doc } = location.state;
			setDoc(doc);
			setEditMode(true);
		}
	}, [location]);

	const handleCreate = async (e) => {
		e.preventDefault();
		e.stopPropagation();

		const tempDoc = { ...doc };
		tempDoc.isFavourite = doc.isFavourite === "true" ? true : false;

		const createdDoc = await createDoctor(tempDoc);

		if (createdDoc instanceof Error)
			handleError(createdDoc);
		else
			navigate("/settings/doctors");
	};

	const handleUpdate = async (e) => {
		e.preventDefault();
		e.stopPropagation();

		const tempDoc = { ...doc };
		tempDoc.isFavourite = doc.isFavourite === "true" ? true : false;

		const updatedDoc = await updateDoctor(tempDoc);
		clearStorage();

		if (updatedDoc instanceof Error)
			handleError(updatedDoc);
		else
			navigate("/settings/doctors");
	};

	const handleError = (e) => {
		console.log(e);
		setError(e);
	};

	return (
		<div>
			<div className="pages__back-button--container">
				<FontAwesomeIcon className="pages__back-button--icon" icon="chevron-left"></FontAwesomeIcon>
				<Link className="pages__back-button--text" to="/settings/doctors">Back</Link>
			</div>
			<div className="pages__modal--container">
				<header className="pages__header--container">
					<h1>{editMode === true ? 'Update Doctor' : 'New Doctor'}</h1>
				</header>
				<Container>
					<form className="pages__form" autoComplete='on' onSubmit={editMode === true ? handleUpdate : handleCreate} style={{ paddingBottom: '60px' }}>
						<Form.Group className="pages__form--item mb-3">
							<Form.Label>Title:</Form.Label>
							<Form.Select
								id='title'
								required
								value={doc.title}
								onChange={(e) => setDoc({ ...doc, title: e.target.value })}>
								<option value=''>--</option>
								<option value='dr'>Dr.</option>
								<option value='mr'>Mr.</option>
								<option value='ms'>Ms.</option>
							</Form.Select>
						</Form.Group>
						<Form.Group className="pages__form--item mb-3">
							<Form.Label>First Name:</Form.Label>
							<FormControl
								id='firstName'
								value={doc.name.firstName}
								placeholder='e.g. John'
								required
								onChange={(e) => setDoc({ ...doc, name: { ...doc.name, firstName: e.target.value } })}
								type='text'>
							</FormControl>
						</Form.Group>
						<Form.Group className="pages__form--item mb-3">
							<Form.Label>Last Name:</Form.Label>
							<FormControl
								id='lastName'
								value={doc.name.lastName}
								placeholder='e.g. Borg'
								required
								onChange={(e) => setDoc({ ...doc, name: { ...doc.name, lastName: e.target.value } })}
								type='text'>
							</FormControl>
						</Form.Group>
						<Form.Group className="pages__form--item mb-3">
							<Form.Label>Speciality:</Form.Label>
							<FormControl
								id='speciality'
								value={doc.speciality}
								placeholder='e.g. Neurologist'
								required
								onChange={(e) => setDoc({ ...doc, speciality: e.target.value })}
								type='text'>
							</FormControl>
						</Form.Group>
						<Form.Group className="pages__form--item mb-3">
							<Form.Label>Email:</Form.Label>
							<FormControl
								id='email'
								value={doc.email}
								placeholder='e.g. john.borg@gmail.com'
								onChange={(e) => setDoc({ ...doc, email: e.target.value })}
								type='email'>
							</FormControl>
						</Form.Group>
						<Form.Group className="pages__form--item mb-3">
							<Form.Label>Mobile Number:</Form.Label>
							<FormControl
								id='mobileNumber'
								value={String(doc.mobile.mobileNumber)}
								placeholder='e.g. 79797979'
								required
								onChange={(e) => setDoc({ ...doc, mobile: { ...doc.mobile, mobileNumber: e.target.value } })}
								type='number'>
							</FormControl>
						</Form.Group>
						<Form.Group className="pages__form--item mb-3">
							<Form.Label>Default clinic:</Form.Label>
							<Form.Select
								id='clinic'
								value={doc.clinic}
								required
								onChange={(e) => setDoc({ ...doc, clinic: e.target.value })}>
								<option value="Clinic 1">Clinic 1</option>
								<option value="Clinic 2">Clinic 2</option>
								<option value="Clinic 3">Clinic 3</option>
								<option value="Clinic 4">Clinic 4</option>
							</Form.Select>
						</Form.Group>
						<Form.Group className="pages__form--item mb-3">
							<Form.Label>Add to favourites list:</Form.Label>
							<Form.Select
								id='isFavourite'
								defaultValue={doc.isFavourite}
								required
								onChange={(e) => setDoc({ ...doc, isFavourite: e.target.value })}>
								<option value="false">No</option>
								<option value="true">Yes</option>
							</Form.Select>
						</Form.Group>
						<div className="pages__form--error">
							{
								error && error instanceof Array ?
									error.map((err, i) => <p key={i}>{err.toString()}</p>)
									: <p>{error.message}</p>
							}
						</div>
						<input className="save-button" type='submit' value={editMode === true ? 'Update' : 'Create'} />
					</form>
				</Container>
			</div>
		</div>
	);
}

export default DoctorDetails;